import React, { FC } from 'react'
import WrapperImage from '../../../../global/wrapperImage'
import { PartnersLocatorFilters } from '../../partnerListings'

type Props = {
  isLocationFilterActive: boolean
  locationFilter: string
  handleFilterClick: any
  handleFilterItemClick: any
  servicePartnersLocations: any
  isTypeFilterActive: boolean
  typeFilter: string
  isCertificationsFilterActive: boolean
  filterCertificationTypes: any
  btnPrimaryIcon: string
  certificationsFilter: string
  handleResetFilters: any
  partnersListingNameTypes: any
}

const Filters: FC<Props> = ({
  isLocationFilterActive,
  locationFilter,
  handleFilterClick,
  handleFilterItemClick,
  servicePartnersLocations,
  isTypeFilterActive,
  typeFilter,
  isCertificationsFilterActive,
  filterCertificationTypes,
  btnPrimaryIcon,
  certificationsFilter,
  handleResetFilters,
  partnersListingNameTypes,
}) => {
  const countryList = (
    <ul>
      <li key="show_all" data-item="location" onClick={handleFilterItemClick}>
        Show all
      </li>

      {servicePartnersLocations &&
        servicePartnersLocations
          .sort((a: any, b: any) => {
            if (a < b) {
              return -1
            }
          })
          .map((location: any, index: any) => (
            <li key={`location_${index}`} data-item="location" onClick={handleFilterItemClick}>
              {location}
            </li>
          ))}
    </ul>
  )

  return (
    <PartnersLocatorFilters>
      <div className="PartnersLocator__filtersContainer">
        <div className="PartnersLocator__filter">
          <span className="PartnersLocator__filterTitle">Location</span>
          <div
            id="location"
            className={`PartnersLocator__filterClosed ${isLocationFilterActive ? 'is-active' : ''}`}
            onClick={handleFilterClick}>
            <span>{locationFilter ? locationFilter : 'Show All'}</span>
          </div>

          <div
            className={`PartnersLocator__filterOpened ${
              isLocationFilterActive ? 'is-active' : ''
            }`}>
            {countryList}
          </div>
        </div>
        {/* Type */}
        <div className="PartnersLocator__filter">
          <span className="PartnersLocator__filterTitle">Type / Tier</span>
          <div
            id="type"
            className={`PartnersLocator__filterClosed ${isTypeFilterActive ? 'is-active' : ''}`}
            onClick={handleFilterClick}>
            <span>{typeFilter ? typeFilter : 'Show All'}</span>
          </div>

          <div className={`PartnersLocator__filterOpened ${isTypeFilterActive ? 'is-active' : ''}`}>
            <ul id="typeItems">
              <li data-item="type" onClick={handleFilterItemClick}>
                Show all
              </li>
              <li data-item="type" onClick={handleFilterItemClick}>
                Diamond
              </li>
              <li data-item="type" onClick={handleFilterItemClick}>
                Platinum
              </li>
              <li data-item="type" onClick={handleFilterItemClick}>
                Gold
              </li>
            </ul>
          </div>
        </div>
        {/* Certifications */}
        <div className="PartnersLocator__filter">
          <span className="PartnersLocator__filterTitle">
            UiPath Services Network Certifications
          </span>

          <div
            id="certifications"
            className={`PartnersLocator__filterClosed ${
              isCertificationsFilterActive ? 'is-active' : ''
            }`}
            onClick={handleFilterClick}>
            <span>{certificationsFilter ? certificationsFilter : 'Show All'}</span>
          </div>

          <div
            className={`PartnersLocator__filterOpened ${
              isCertificationsFilterActive ? 'is-active' : ''
            }`}>
            <ul>
              {filterCertificationTypes.map((certification: any, i: number) => {
                return (
                  <li data-item="certifications" onClick={handleFilterItemClick} key={i}>
                    {certification}
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
        {/* Reset */}
        <div className="PartnersLocator__filter">
          <span
            id="resetFilters"
            className={`PartnersLocator__resetFilters ${
              locationFilter || typeFilter || certificationsFilter
                ? 'PartnersLocator__resetFilters--active'
                : ''
            }`}
            onClick={handleResetFilters}>
            Reset filters <i className="fa fa-times"></i>
          </span>
        </div>
        {/* Become a partner */}
        <div className="PartnersLocator__filter PartnersLocator__filter--desktop">
          <h4 className="PartnersLocator__becomePartnerTitle">
            Apply to become a UiPath{' '}
            {partnersListingNameTypes && partnersListingNameTypes[0]
              ? partnersListingNameTypes[0].value
              : 'Service Partner'}
          </h4>

          <p className="PartnersLocator__becomePartnerDesc">
            Help companies along their digital transformation journey by connecting them with the
            UiPath RPA Platform
          </p>

          <a
            className="PartnersLocator__becomePartnerCTA Button Button--secondary"
            href="https://www.uipath.com/partners/become-a-partner"
            rel=" noopener">
            Become a partner
            <WrapperImage src={btnPrimaryIcon} alt="arrow" width={24} height={24} threshold={650} />
          </a>
        </div>
      </div>
    </PartnersLocatorFilters>
  )
}

export default Filters
